import Vue from 'vue'
import { SwipeList, SwipeOut } from 'vue-swipe-actions'
import 'vue-swipe-actions/dist/vue-swipe-actions.css'

Vue.use(SwipeList)
Vue.use(SwipeOut)
